import React from "react";

export const Ongkir = (props) => {
  const { name, harga, estimasi } = props.data;

  return (
    <div className="jasa_kirim">
      <div className="description">
      <p>
        <b>{name}</b>
        </p>
        <p>
        <b>RP {harga.toFixed(3)}</b>
        </p>
        <p> Estimasi kedatangan: {estimasi}</p>
      </div>
    </div>
  );
};